
export const Search = ( { search,setSearch,setcurrentSelected } ) => {

    const onSearchChange = ({target}) =>{
      setcurrentSelected('all')
        setSearch( target.value )
      }

  return (
    <form 
    className=" formSerchSteam"
  >
    

      <input 
          type="search default" 
          className="search col-10"
          placeholder="buscar producto"
          name="search"
          value= { search } 
          onChange={ onSearchChange }
         

      ></input>
      {search === ''
      ?
      <i className="fa-solid fa-magnifying-glass btn-search" ></i>
      :
      <i class="fa-solid fa-circle-xmark btn-search" onClick={()=> setSearch('')}></i>
      }


     
  </form> 
  )
}
